export const armChipTestIds = (arm, index)=>({
        Status: arm.Status(index),
        PaymentMethod: arm.PaymentMethod(index),
        AmendmentStatus: arm.AmendmentStatus(index),
        HasCredit: arm.HasCredit(index),
        PriceIncrease: arm.PriceIncrease(index),
        EffectiveDate: arm.EffectiveDate(index),
        ApprovalDate: arm.ApprovalDate(index),
        ClientName: arm.ClientName(index),
        AgreementTitle: arm.AgreementTitle(index),
        ContactName: arm.ContactName(index),
        Assignee: arm.Assignee(index),
        LastBilled: arm.LastBilled(index),
        Occurrence: arm.Occurrence(index),
        AutomaticServices: arm.AutomaticServices(index),
        ServiceName: arm.ServiceName(index),
        ServiceStatus: arm.ServiceStatus(index),
        BillingTrigger: arm.BillingTrigger(index),
        BundleName: arm.BundleName(index),
        OrGroup: arm.OrGroup(index)
    });
export const armReactKeys = (arms)=>{
    const occurrencesByContent = new Map();
    return arms.map((arm)=>{
        var _occurrencesByContent_get;
        const content = JSON.stringify(arm);
        const occurrence = (_occurrencesByContent_get = occurrencesByContent.get(content)) !== null && _occurrencesByContent_get !== void 0 ? _occurrencesByContent_get : 0;
        occurrencesByContent.set(content, occurrence + 1);
        return "".concat(content, "#").concat(occurrence);
    });
};
export const rebuildOrArms = (arms, index, nextArm)=>{
    const nextArms = arms.map((arm, armIndex)=>armIndex === index ? nextArm : arm).filter((arm)=>Object.keys(arm).length > 0);
    return nextArms.length === 0 ? undefined : nextArms;
};
